import SettingIntermediate from '../../Classes/Import/SettingIntermediate';

// when handed a settings module and app context, this function will digest it and return it as appropriate object
export default function digestSettings(struct) {
    if (struct._type === "Settings") {
        return new SettingIntermediate(struct);
    }

    return undefined;
}